import React, { useState, useEffect } from 'react';
import MUIDataTable from 'mui-datatables';
import Card from '@mui/material/Card';
import CardHeader from 'components/Card/CardHeader';
import CardBody from 'components/Card/CardBody';
import CardFooter from 'components/Card/CardFooter.jsx';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import Button from 'components/CustomButtons/Button.jsx';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import CircularProgress from '@mui/material/CircularProgress';
import GridItem from 'components/Grid/GridItem.jsx';
import GridContainer from 'components/Grid/GridContainer.jsx';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import TextField from '@material-ui/core/TextField';
import withStyles from '@material-ui/core/styles/withStyles';
import extendedFormsStyle from 'assets/jss/material-dashboard-react/views/extendedFormsStyle.jsx';
import UserSearch from 'components/UserSearch/UserSearch.jsx';

const CommPermCommComp = (props) => {
  const [dialogOpen, setDialogOpen] = useState(false);
  const [dialogTitle, setDialogTitle] = useState('');
  const [dialogButton, setDialogButton] = useState('');
  const [fieldDisabled, setFieldDisabled] = useState(false);
  const [dialogType, setDialogType] = useState('add');
  const [data, setData] = useState([]);
  const [message, setMessage] = useState('');
  const [id, setID] = useState('');
  const [roleID, setRoleID] = useState('');
  const [filteredPermRole, setFilteredPermRole] = useState([]);
  const [showUserSearch, setShowUserSearch] = useState(false);
  const [selectedUserNameEmail, setSelectedUserNameEmail] = useState('');
  const [selectedUserID, setSelectedUserID] = useState('');

  const { getPermCommFromComm, getPermCommRoles, comm_name_id } = props;
  useEffect(() => {
    getPermCommFromComm(comm_name_id);
    getPermCommRoles(comm_name_id);
  }, [getPermCommFromComm, getPermCommRoles, comm_name_id]);

  const handleEditClick = (e) => {
    var filteredPermRoleTemp = props.permComm_role_list.filter((obj) => obj.perm_comm_id === 0);
    var filteredPermRoleTempEdit = props.permComm_role_list.filter((obj) => obj.perm_comm_id === e[0]);
    filteredPermRoleTemp = [...filteredPermRoleTemp, ...filteredPermRoleTempEdit];
    setID(e[0]);
    setSelectedUserID(e[1]);
    setRoleID(e[2]);
    setSelectedUserNameEmail(e[3]);
    setMessage('');
    setDialogTitle('Edit');
    setDialogButton('Save');
    setFieldDisabled(false);
    setDialogType('update');
    setDialogOpen(true);
    setFilteredPermRole(filteredPermRoleTemp);
    props.resetMessage('');
  };

  const handleDeleteClick = (e) => {
    var filteredPermRoleTemp = props.permComm_role_list.filter((obj) => obj.perm_comm_id === 0);
    var filteredPermRoleTempEdit = props.permComm_role_list.filter((obj) => obj.perm_comm_id === e[0]);
    filteredPermRoleTemp = [...filteredPermRoleTemp, ...filteredPermRoleTempEdit];
    setID(e[0]);
    setSelectedUserID(e[1]);
    setRoleID(e[2]);
    setSelectedUserNameEmail(e[3]);
    setMessage('');
    setDialogTitle('Delete');
    setDialogButton('Confirm Delete');
    setFieldDisabled(true);
    setDialogType('delete');
    setDialogOpen(true);
    setFilteredPermRole(filteredPermRoleTemp);
    props.resetMessage('');
  };
  const handleNewClick = (e) => {
    var filteredPermRoleTemp = props.permComm_role_list.filter((obj) => obj.perm_comm_id === 0);
    setSelectedUserID('');
    setSelectedUserNameEmail('');
    setRoleID('');
    setMessage('');
    setDialogTitle('Add New');
    setDialogButton('Save');
    setFieldDisabled(false);
    setDialogType('add');
    setDialogOpen(true);
    setFilteredPermRole(filteredPermRoleTemp);
    props.setSelectedUser('', 0);
    props.resetMessage('');
  };
  useEffect(() => {
    setMessage(props.message);
    if (props.refreshPermComm) {
      props.getPermCommFromComm(props.comm_name_id);
      props.getPermCommRoles(props.comm_name_id);
      setDialogOpen(false);
    }
    var rowItems = [];

    if (props.commPermComm_list.length > 0) {
      for (let i = 0; i < props.commPermComm_list.length; i++) {
        var colItems = [];
        colItems.push(i + 1);
        colItems.push(props.commPermComm_list[i].role_title);
        colItems.push(props.commPermComm_list[i].user_name);
        colItems.push(
          <div>
            <IconButton
              onClick={handleEditClick.bind(this,
                [props.commPermComm_list[i].id,
                  props.commPermComm_list[i].user_id,
                  props.commPermComm_list[i].role_id,
                  `${props.commPermComm_list[i].user_id} ${props.commPermComm_list[i].user_name} (${props.commPermComm_list[i].user_email})`,
                ])}
              title="Edit row"
            >
              {' '}
              <EditIcon />
            </IconButton>
            <IconButton
              onClick={handleDeleteClick.bind(this,
                [props.commPermComm_list[i].id,
                  props.commPermComm_list[i].user_id,
                  props.commPermComm_list[i].role_id,
                  `${props.commPermComm_list[i].user_id} ${props.commPermComm_list[i].user_name} (${props.commPermComm_list[i].user_email})`,
                ])}
              title="Delete row"
            >
              {' '}
              <DeleteIcon />
            </IconButton>
          </div>,
        );
        rowItems.push(colItems);
      }
    }

    var filteredPermRoleTemp = props.permComm_role_list.filter((obj) => obj.perm_comm_id === 0);
    var filteredPermRoleTempEdit = props.permComm_role_list.filter((obj) => obj.perm_comm_id === id);
    filteredPermRoleTemp = [...filteredPermRoleTemp, ...filteredPermRoleTempEdit];

    setData(rowItems);
    setFilteredPermRole(filteredPermRoleTemp);

    if (props.selected_user_id !== 0) {
      setSelectedUserNameEmail(props.selected_user);
      setSelectedUserID(props.selected_user_id);
      setShowUserSearch(false);
    }
  }, [props]);

  const handleDialogClose = (e) => {
    setDialogOpen(false);
    setMessage('');
  };
  const handleDialogConfirm = (e) => {
    if (dialogType === 'add') {
      props.createPermComm({
        comm_name_id: props.comm_name_id.toString(),
        user_id: selectedUserID.toString(),
        role_id: roleID.toString(),
      });
    } else if (dialogType === 'update') {
      props.updatePermComm(id, {
        comm_name_id: props.comm_name_id.toString(),
        user_id: selectedUserID.toString(),
        role_id: roleID.toString(),
      });
    } else if (dialogType === 'delete') {
      props.deletePermComm(id);
    }
  };
  const onRoleIDChange = (e) => {
    setRoleID(e.target.value);
    setMessage('');
  };

  const handleShowSearchClick = (e) => {
    props.setSelectedUser('', 0);
    setShowUserSearch(true);
  };

  const handleRemoveUserClick = (e) => {
    setSelectedUserNameEmail('');
    setSelectedUserID('');
  };

  const { classes } = props;
  const columns = [
    'Serial',
    'Role',
    'User',
    '',
  ];
  const options = {
    filterType: 'dropdown',
    responsive: 'standard',
    filter: true,
    selectableRows: 'none',
    rowsPerPage: 100,
    selectToolbarPlacement: 'none',
  };

  return (
    <div>
      {props.requesting && <CircularProgress size={44} style={{ position: 'absolute', top: '50%', left: '50%' }} />}
      <Card>
        <CardHeader color="primary" style={{ textAlign: 'left', paddingTop: '30px' }}>
          <b>Permament Committee</b>
          <p className={classes.cardCategoryWhite}>
            Here is the list of users in a committee/council/team that are required to access an application in a workflow simultaneously. This committee will remain same for all the applications in the workflow.
          </p>
        </CardHeader>
        <CardBody>
          <MUIDataTable
            title={(
              <Button
                onClick={handleNewClick.bind(this)}
                color="primary"
                title="Create a new Permament Committee"
                round
                disabled={parseInt(localStorage.getItem('workflow_state'), 10) > 0 || filteredPermRole.length === 0}
              >
                {' '}
                New Permament Committee Member
              </Button>
            )}
            data={data}
            columns={columns}
            options={options}
          />
          <Dialog fullWidth open={dialogOpen} onClose={handleDialogClose.bind(this)} aria-labelledby="form-dialog-title">
            <DialogContent>
              <Card>
                <CardHeader color="primary" style={{ textAlign: 'left', paddingTop: '30px' }}>
                  <b>{dialogTitle}</b>
                </CardHeader>
                <CardBody>
                  <div style={{ color: 'red', textAlign: 'center' }}>{message}</div>
                  <GridContainer>
                    <GridItem xs={12} sm={12} md={12}>
                      <TextField
                        required={false}
                        fullWidth
                        label="Committee Name"
                        value={props.commName_title}
                        disabled={fieldDisabled}
                        InputProps={{ readOnly: true }}
                      />
                    </GridItem>
                  </GridContainer>
                  <br />
                  <GridContainer>
                    <GridItem xs={12} sm={12} md={12}>
                      <FormControl fullWidth className={classes.formControl} disabled={fieldDisabled}>
                        <InputLabel id="roleIdLabel">Permanent Committee Role</InputLabel>
                        <Select
                          labelId="roleIdLabel"
                          id="roleIdSelect"
                          value={roleID}
                          onChange={onRoleIDChange.bind(this)}
                        >
                          {filteredPermRole.map((item) => (
                            <MenuItem key={item.id} value={item.id}>
                              {filteredPermRole.find((p) => p.id === item.id).title}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </GridItem>
                  </GridContainer>
                  <br />
                  <div style={{ display: !showUserSearch ? 'block' : 'none' }}>
                    <GridContainer>
                      <GridItem xs={12} sm={12} md={10}>
                        <TextField
                          required={false}
                          fullWidth
                          label="Selected User"
                          onClick={handleShowSearchClick.bind(this)}
                          value={selectedUserNameEmail}
                          disabled
                          InputProps={{ readOnly: true }}
                        />
                      </GridItem>
                      <GridItem xs={12} sm={12} md={1}>
                        <IconButton
                          onClick={handleShowSearchClick.bind(this)}
                          title="Change User"
                        >
                          <EditIcon />
                        </IconButton>
                      </GridItem>
                      <GridItem xs={12} sm={12} md={1}>
                        <IconButton
                          onClick={handleRemoveUserClick.bind(this)}
                          title="Remove User"
                        >
                          <DeleteIcon />
                        </IconButton>
                      </GridItem>
                    </GridContainer>
                  </div>
                  <div style={{ display: showUserSearch ? 'block' : 'none' }}>
                    <UserSearch user_type="admin" />
                  </div>
                </CardBody>
                <CardFooter style={{ textAlign: 'left' }} />
              </Card>
            </DialogContent>
            <DialogActions>
              <Button onClick={handleDialogClose.bind(this)} color="primary" round>
                Cancel
              </Button>
              <Button onClick={handleDialogConfirm.bind(this)} color="primary" round>
                {dialogButton}
              </Button>
            </DialogActions>
          </Dialog>
        </CardBody>
      </Card>
    </div>
  );
};
export default withStyles(extendedFormsStyle)(CommPermCommComp);
